export const CUSTOM_BLUE = "#3C5D7B";
export const CUSTOM_LIGHT_GRAY = "#9FADBD";
export const CUSTOM_DARK_GRAY = "#6B7888";
export const CUSTOM_BURGUNDY = "#784E5F";
export const CUSTOM_PINK = "#AD7F92";
